export default __webpack_public_path__ + "static/media/pants.3c43799d.svg";